import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache) {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createBlock(_component_Icon, {
    class: "burger pointer",
    stroke: "var(--brand-700)",
    size: "3.2rem",
    icon: "menu-03",
    onClick: _cache[0] || (_cache[0] = $event => (_ctx.$dispatch('toggle-burger')))
  }))
}